module.exports = __webpack_public_path__ + "team-bottom-bw.svg?00fa564a93252e01f65c4f5ba29251fd";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backgrounds/team-bottom-bw.svg
// module id = 83
// module chunks = 0